var map = {
	"./DocPage": [
		224984,
		3978,
		68526,
		20467,
		84477,
		24984
	],
	"./DocPage.tsx": [
		224984,
		3978,
		68526,
		20467,
		84477,
		24984
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 452644;
module.exports = webpackAsyncContext;